import { useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { fromJS } from 'immutable';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { ANALYTICS_ALL_PAGES } from 'reporting-data/constants/dataTypes';
import { IN } from 'reporting-data/constants/operators';
import { ASC, DESC } from 'reporting-data/constants/sortOrder';
import { fromMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { ALL_METRICS } from '../../constants/reporting';
import { jsx as _jsx } from "react/jsx-runtime";
const getReport = ({
  dateRange,
  metricsToDisplay,
  metric,
  metricSortDir,
  mabVariantsMap,
  variantIds,
  handleSortMetricColumn
}) => {
  const columns = metricsToDisplay.reduce((acc, metricToDisplay) => {
    const {
      tooltipKey
    } = ALL_METRICS[metricToDisplay];
    acc[metricToDisplay] = {
      tooltipI18nKey: tooltipKey,
      onSort: handleSortMetricColumn
    };
    return acc;
  }, {
    id: {
      onClick: ({
        value
      }) => {
        if (value in mabVariantsMap) {
          window.open(mabVariantsMap[value].url);
        }
      }
    }
  });
  const metrics = metricsToDisplay.map(metricToDisplay => ({
    metricTypes: ALL_METRICS[metricToDisplay].metricTypes,
    property: metricToDisplay
  }));
  return fromJS({
    chartType: TABLE,
    config: {
      configType: AGGREGATION,
      dataType: ANALYTICS_ALL_PAGES,
      dimensions: ['id'],
      filters: {
        custom: [{
          operator: IN,
          property: 'filters',
          values: variantIds
        }],
        dateRange: {
          property: 'sessionDate',
          value: dateRange
        }
      },
      metrics,
      sort: [{
        order: metricSortDir,
        property: metric
      }]
    },
    displayParams: {
      columns,
      hidePagination: true,
      rhumbConfig: {
        renderSuccessMarker: () => /*#__PURE__*/_jsx(NavMarker, {
          name: "MAB_VARIANTS_TABLE_LOADED"
        })
      },
      shouldTruncateHeader: false,
      showTotals: true
    }
  });
};
const MABVariantsTable = ({
  dateRange,
  metricsToDisplay,
  mabVariantsMap,
  variantIds
}) => {
  const [metricSortDir, setMetricSortDirection] = useState(DESC);
  const [metric, setMetric] = useState('rawViews');
  const handleSortMetricColumn = clickedMetric => {
    const {
      property: clickedProperty
    } = fromMetricKey(clickedMetric);
    if (clickedProperty === metric) {
      const newSortDir = metricSortDir === ASC ? DESC : ASC;
      setMetricSortDirection(newSortDir);
    } else {
      setMetric(clickedProperty);
    }
  };
  const report = getReport({
    variantIds,
    dateRange,
    mabVariantsMap,
    metric,
    metricSortDir,
    metricsToDisplay,
    handleSortMetricColumn
  });
  if (!report) {
    return null;
  }
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-test-id": "mab-variants-table",
    compact: true,
    children: /*#__PURE__*/_jsx(PlatformReportResolver, {
      report: report,
      useInlineLabels: false
    })
  });
};
export default MABVariantsTable;